/**
 * The values here should match the values in the tz database
 * (https://en.wikipedia.org/wiki/Tz_database)
 * which is used by pytz, the Python library we use in API.
 *
 * !! NOTE IF YOU ARE ADDING NEW TIMEZONES HERE !!
 * We should prefer location-based timezones (e.g. America/Toronto) over explicit timezones
 * (e.g. EST) to avoid problems with Daylight Saving Time.
 */

export default [
  {
    "value": "GMT",
    "label": "Greenwich Mean Time - GMT"
  },
  {
    "value": "UTC",
    "label": "Universal Coordinated Time - UTC"
  },
  {
    "value": "CET",
    "label": "European Central Time - ECT"
  },
  {
    "value": "Europe/London",
    "label": "London Time"
  },
  {
    "value": "Europe/Paris",
    "label": "Paris Time"
  },
  {
    "value": "EET",
    "label": "Eastern European Time - EET"
  },
  {
    "value": "Egypt",
    "label": "(Arabic) Egypt Standard Time - ART"
  },
  {
    "value": "Africa/Nairobi",
    "label": "Eastern African Time - EAT"
  },
  {
    "value": "Iran",
    "label": "Middle East Time - MET"
  },
  {
    "value": "Asia/Dubai",
    "label": "Near East Time - NET"
  },
  {
    "value": "Etc/GMT-5",
    "label": "Pakistan Lahore Time - PLT"
  },
  {
    "value": "Asia/Kolkata",
    "label": "India Standard Time - IST"
  },
  {
    "value": "Etc/GMT-6",
    "label": "Bangladesh Standard Time - BST"
  },
  {
    "value": "Etc/GMT-7",
    "label": "Vietnam Standard Time - VST"
  },
  {
    "value": "Etc/GMT-8",
    "label": "China Taiwan Time - CTT"
  },
  {
    "value": "Etc/GMT-9",
    "label": "Japan Standard Time - JST"
  },
  {
    "value": "Australia/Adelaide",
    "label": "Australia Central Time - ACT"
  },
  {
    "value": "Australia/Melbourne",
    "label": "Australia Eastern Time - AET"
  },
  {
    "value": "Etc/GMT-11",
    "label": "Solomon Standard Time - SST"
  },
  {
    "value": "Pacific/Auckland",
    "label": "New Zealand Standard Time - NST"
  },
  {
    "value": "Etc/GMT+11",
    "label": "Midway Islands Time - MIT"
  },
  {
    "value": "US/Hawaii",
    "label": "Hawaii Standard Time - HST"
  },
  {
    "value": "US/Alaska",
    "label": "Alaska Standard Time - AST"
  },
  {
    "value": "US/Pacific",
    "label": "Pacific Standard Time - PST"
  },
  {
    "value": "MST",
    "label": "Phoenix Standard Time - PNT"
  },
  {
    "value": "MST",
    "label": "Mountain Standard Time - MST"
  },
  {
    "value": "America/Regina",
    "label": "Central Standard Time - CST"
  },
  {
    "value": "US/Eastern", // Same as EST. Most clients use this currently
    "label": "Eastern Standard Time - EST"
  },
  {
    "value": "US/East-Indiana",
    "label": "Indiana Eastern Standard Time - IET"
  },
  {
    "value": "America/Puerto_Rico",
    "label": "Puerto Rico and US Virgin Islands Time - PRT"
  },
  {
    "value": "Canada/Newfoundland",
    "label": "Canada Newfoundland Time - CNT"
  },
  {
    "value": "America/Argentina/Buenos_Aires",
    "label": "Argentina Standard Time - AGT"
  },
  {
    "value": "Brazil/East",
    "label": "Brazil Eastern Time - BET"
  },
  {
    "value": "Africa/Cairo",
    "label": "Central African Time - CAT"
  },
  {
    "value": "Asia/Bangkok",
    "label": "Asia/Bangkok"
  },
  {
    "value": "Asia/Singapore",
    "label": "Asia/Singapore"
  },
  {
    "value": "Asia/Kuala_Lumpur",
    "label": "Asia/Kuala Lumpur"
  },
  {
    "value": "Asia/Manila",
    "label": "Asia/Manila"
  },
  {
    "value": "Asia/Jakarta",
    "label": "Asia/Jakarta"
  },
  {
    "value": "Asia/Brunei",
    "label": "Asia/Brunei"
  },
  {
    "value": "Asia/Jayapura",
    "label": "Asia/Jayapura"
  },
  {
    "value": "Asia/Yangon",
    "label": "Asia/Yangon"
  },
  {
    "value": "Asia/Phnom_Penh",
    "label": "Asia/Phnom Penh"
  },
  {
    "value": "Asia/Ho_Chi_Minh",
    "label": "Asia/Ho Chi Minh"
  }
];
